@let connectedDropListIds =
  cmsTicketCategoryService.getConnectedDropListIds(ticketType());

<div [ngClass]="isDisabled() ? 'pointer-events-none opacity-50' : ''">
  <div
    class="flex max-h-[calc(100vh-18rem)] w-full flex-col gap-5 overflow-y-auto">
    <div
      class="border-standard-outline-light flex flex-row items-center justify-between rounded-lg border-1 p-2">
      <span class="material-symbols-rounded">search</span>
      <input
        class="text-standard-text-secondary w-full border-0 outline-none focus:ring-0"
        placeholder="Suche"
        [attr.data-testid]="'search-' | appendTestId: 'input'"
        [id]="'search-tickets'"
        [formControl]="searchControl" />
    </div>
    <div
      id="outline"
      class="border-standard-outline-light flex w-full flex-col rounded-lg border-1">
      <div
        class="bg-standard-surface text-standard-text-primary flex min-h-15 w-full items-center rounded-lg p-2 font-semibold"
        tabindex="0"
        id="ticket-drag-and-drop-list-header"
        [attr.data-testid]="'ticket-drag-and-drop-list-header'">
        {{ cmsTextProvider.ticketCategories.designation }}
        <span
          (click)="toggleSort()"
          class="material-symbols-rounded cursor-pointer pl-1 text-inherit">
          {{
            sortState === SortOrder.ASC
              ? 'arrow_downward_alt'
              : sortState === SortOrder.DESC
                ? 'arrow_upward_alt'
                : 'height'
          }}
        </span>
      </div>
      <div
        cdkDropList
        [cdkDropListConnectedTo]="connectedDropListIds"
        [cdkDropListAutoScrollStep]="5"
        [cdkDropListData]="visibleTickets"
        (cdkDropListDropped)="dropTicket($event)"
        (cdkDropListEntered)="
          changePlaceholder(EDropListViewMode.UnassignedList);
          this.previewVisible.set(true)
        "
        (cdkDropListExited)="
          changePlaceholder(EDropListViewMode.None);
          this.previewVisible.set(false)
        "
        cdkScrollable
        [id]="cmsTicketCategoryService.getUnassignedDropListId(ticketType())"
        class="min-h-15 max-w-screen overflow-y-auto"
        [ngClass]="isBeingDragged() ? 'border-info-main border-2' : ''">
        @if (visibleTickets.length > 0) {
          @for (ticket of visibleTickets; track $index) {
            <div
              cdkDrag
              (cdkDragStarted)="
                toggleTicketDragSignal(true);
                changePlaceholder(EDropListViewMode.UnassignedList)
              "
              [cdkDragData]="ticket"
              (cdkDragEnded)="toggleTicketDragSignal(false)"
              class="border-standard-outline-light text-standard-text-primary flex min-h-20 w-full items-center justify-between border-t-1 p-2 transition-transform ease-in-out"
              [ngClass]="
                !isBeingDragged()
                  ? 'hover:bg-standard-hover-main cursor-grab'
                  : ''
              ">
              <div [attr.data-testid]="'ticket-' + $index">
                {{ ticket.name }}
              </div>
              <span class="material-symbols-rounded mr-5">drag_indicator</span>
              <ng-template cdkDragPreview>
                <div
                  class="!border-standard-outline-light !bg-standard-background !flex !justify-center !rounded-lg !border-1 !px-10 !py-2">
                  {{ ticket.ticketData?.ticketId }}
                </div>
              </ng-template>
              <ng-template cdkDragPlaceholder>
                @switch (
                  ticketDragAndDropSupportService.currentDropListViewMode()
                ) {
                  @case (EDropListViewMode.UnassignedList) {
                    <div
                      class="border-standard-outline-light hover:bg-standard-hover-main flex min-h-20 w-full cursor-grab items-center justify-between border-t-1 p-2">
                      <div [attr.data-testid]="'ticket-' + $index">
                        {{ ticket.name }}
                      </div>
                      <span class="material-symbols-rounded mr-5"
                        >drag_indicator</span
                      >
                    </div>
                  }
                  @case (EDropListViewMode.Category) {
                    <div
                      class="border-standard-outline-light hover:bg-standard-hover-main flex min-h-20 w-full cursor-grab items-center justify-between border-t-1 p-2">
                      <div [attr.data-testid]="'ticket-' + $index">
                        {{ ticket.name }}
                      </div>
                      <div class="flex flex-row items-center justify-end gap-4">
                        <div class="flex flex-col items-center justify-end">
                          <span class="material-symbols-rounded cursor-pointer"
                            >expand_less</span
                          >
                          <span class="material-symbols-rounded"
                            >drag_handle</span
                          >
                          <span class="material-symbols-rounded cursor-pointer"
                            >expand_more</span
                          >
                        </div>
                        <span
                          class="material-symbols-rounded mr-5 cursor-pointer"
                          >close</span
                        >
                      </div>
                    </div>
                  }
                  @default {
                    <div class="min-h-20"></div>
                  }
                }
              </ng-template>
            </div>
          }
        } @else if (visibleTickets.length === 0 && !isBeingDragged()) {
          <div class="flex min-h-15 w-full items-center justify-center">
            Keine Tickets gefunden.
          </div>
        }
      </div>
    </div>
  </div>
</div>
